<template>
  <div class="did">
    <shell>
      <div class="container m-auto">
        <div class="w-full lg:w-1/2 m-auto">
          <t-text lvl="1">Import notes from pinboard.in</t-text>
          <t-text lvl="2" class="my-4">To <a href="www.tatatap.com/export-pinboard-bookmarks-for-tap">import Notes from Pinboard</a> create a JSON export from the settings <a href="https://pinboard.in/settings/backup" target="_blank">Backup page</a>.</t-text>
          <t-text lvl="2" class="my-4">For complete instructions see <a href="www.tatatap.com/importing-notes">the documentation.</a></t-text>
          <p v-if="error" class="text-red-dark py-6">{{error}}</p>
          <form @submit.prevent="handleSubmit">
          <div class="my-4">
            <t-label>Note Template</t-label>
            <textarea v-model="tpl" class="w-full p-2 leading-normal font-mono border-gray border" rows="10"></textarea>
            <t-text lvl="2" class="my-4 leading-normal">Available template values are <span class="font-mono">date</span>: date text formatted for Tap,  <span class="font-mono">toread</span>: true/false value, <span class="font-mono">tags</span>: a list of tag values, <span class="font-mono">href</span>: the bookmark URL, and <span class="font-mono">description</span>: includes all text saved in association with the bookmark.</t-text>
            <t-text lvl="2" class="my-4 leading-normal">Template values must be surrounded with double curly braces, ie <span class="font-mono">{{curlyEx}}</span></t-text>
          </div>
          <diV class="my-4">
            <t-label>Pinboard JSON Export File</t-label>
            <input ref="file" type="file" name="filename" @change="handleFileChange" class="w-full bg-white p-2 border-gray border" />
            
          </diV>
          

          <div class="my-4">
            <t-text lvl="2">Preview</t-text>
            <p>Found {{notes.length}} note{{notes.length > 1 ? 's' : ''}}</p>
            <div v-if="notes.length">
              <div class="bg-white my-4" v-for="n in notes.slice(0, 3)"><note :item="{}" :text="n.text" /></div>
            </div>
            <div v-else class="my-4 p-4 bg-gray-lighter rounded text-gray-darker">
              Select a Pinboard JSON export file using the form above
            </div>
          </div>
          <t-button type="submit" :disabled="disabled || !notes || !notes.length">
            <span v-if="disabled">Uploading...</span>
            <span v-else>Looks good, save the notes</span>
          </t-button>
          </form>
        </div>
      </div>
    </shell>
  </div>
</template>
<script>
 const {Liquid} = require('liquidjs')
 
 import { DateTime } from 'luxon'
 import { mapState, mapActions } from 'vuex'
 import eventBus from '@/eventBus'
 import Shell from '@/components/Shell'
 import Note from '@/components/Note'
 

 const engine = new Liquid()

 
 const TPL = `{{date}}

/"Bookmarks" {% if toread == "yes" %}Todo Read{% endif %}

{{href}}

{{description}}

{% for tag in tags %}#{{tag}} {%endfor%}`

 export default {
   props: {

   },

   components: { Shell },
   data () {
     return {
       tpl: TPL,
       notes: [],
       rows: [],
       error: '',
       disabled: false,
       curlyEx: '{{value}}'
     }
   },

   methods: {
     ...mapActions(['bulkAddRecords']),
     async handleFileChange (event) {
       const f = event.target.files[0]
       let reader = new FileReader();
       const vm = this;
       // Closure to capture the file information.
       reader.onload = (function(file) {
         return async function(e) {
           const rows = JSON.parse(e.target.result)
           if (rows && rows.length > 2500) {
             vm.error = 'Too many notes in the import (> 2500). If you can\'t break up the import into smaller chunks, get in touch hello@tatatap.com and we\'ll get it sorted out. Thanks.'
             return
           }

           vm.rows = rows
         };
       })(f);

       // Read in the image file as a data URL.
       reader.readAsText(f);
     },


     async renderPreview (rows) {
       const tpl = engine.parse(this.tpl)

       

       this.notes = await Promise.all(rows.map(async (r) => {


         const data = {...r}
         data.date = DateTime.fromISO(new Date(r.time).toISOString()).toISODate()
         if (!!data.tags && data.tags.length) {
           data.tags = data.tags.split(' ')
         } else {
           data.tags = []
         }

         data.description = [data.description || '', data.extended || ''].join('\n\n').trim()

         const note = await engine.render(tpl, data)
         return {text: note, id: r.hash}
       }))
     },

     resetForm () {
       this.rows = []
       this.$refs.file.value = ''
       this.tpl = TPL
     },

     async handleSubmit () {
       this.disabled = true

       const res = await this.bulkAddRecords({notes: this.notes, type: 'PINBOARD'})

       if (res && res.err) {
         this.error = res.err
       } else {

         this.$toasted.show(`Successfully imported ${res.length} note${res.length > 1 ? 's' : ''}.`, {duration: 3000})


         this.$router.replace({path: '/imports/' + res[0].short_id})
       }

       this.disabled = false

       this.resetForm()
     }
   },

   watch: {
     rows (to) {
       this.renderPreview(to, this.tpl)
     },
     tpl (to) {
       this.renderPreview(this.rows, to)
     }
   }

 };
</script>
